<template>
  <span  class="legs">
    <v-icon>{{icon}}
    </v-icon>
    <span v-if="icon == 'mdi-walk'" class="duration">{{Math.round(leg.duration/60)}}</span>
    <span v-if="leg.line !== undefined" class="line_description" :style="{color: line_color, backgroundColor: line_background_color, borderColor: border_color}">
      {{leg.line.publicCode}}
    </span>
    <v-icon v-if="!last_leg">mdi-chevron-right</v-icon>
  </span>
  
</template>

<script>
import Vuetify from 'vuetify';
import moment from 'moment';

export default {
  props: ['leg', 'last_leg'],
  data() {
    return {
    }
  },
  computed: {
    icon: function() {
      switch(this.leg.mode) {
        case "foot":
          return "mdi-walk";
        case "bus":
          return "mdi-bus";
        case "metro":
          return "mdi-subway";
        case "tram":
          return "mdi-tram";
        case "rail":
          return "mdi-train";
      }

      return "mdi-help";
    },
    line_color: function() {
      if (this.leg.line.presentation.textColour !== undefined) {
        return '#' + this.leg.line.presentation.textColour;
      }
      return '#000000';
    },

    line_background_color: function() {
      console.log(this.leg.line.presentation.colour);
      if (this.leg.line.presentation.colour !== undefined) {
        return '#' + this.leg.line.presentation.colour;
      }
      return '#ffffff';
    },

    border_color: function() {
      if (this.leg.line.presentation.colour !== undefined) {
        return '#' + this.leg.line.presentation.colour;
      }
      return '#000000';
    }
  }
};

</script>
<style scoped>
.line_description {
  border: 0.5px solid black;
  border-radius: 5px;
  padding: 2px;
  margin: 4px;
  font-size: 80%;
}

.duration {
  font-size: 70%;
  vertical-align: -10px;
  margin-left: -6px;
  
}

.legs {
  white-space:nowrap;
}


</style>